import { render, staticRenderFns } from "./GuestFeatureRequestedProviderTable.vue?vue&type=template&id=de3600d4&scoped=true&"
import script from "./GuestFeatureRequestedProviderTable.vue?vue&type=script&lang=js&"
export * from "./GuestFeatureRequestedProviderTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de3600d4",
  null
  
)

export default component.exports